export default __webpack_public_path__ + "9701ff61776651e47087de6efd811c66.svg";